import React from "react";
import {TableCell, TableRow} from "../CourierStatsWidget.styles";

export const TotalPoolDataTable = ({filteredPools}) => {
    return (
        <TableRow
            style={{
                fontWeight: "bold",
                borderTop: "2px solid #f0f0f0"
            }}
        >
            <TableCell bold>Toplam</TableCell>
            <TableCell align="center">-</TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.queuedDeliveryCount, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.inSlotCouriersCount, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.unAvailableCouriersCount, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.activeCouriersCount, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.onDeliveryCouriersCount, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.availableCouriersCount, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.slotLimit, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.poolCouriersCount, 0)}
            </TableCell>
            <TableCell align="center">-</TableCell>
            <TableCell align="center">-</TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.activeDeliveryCount, 0)}
            </TableCell>
            <TableCell align="center">
                {filteredPools.reduce((sum, pool) => sum + pool.deliveredCount, 0)}
            </TableCell>
        </TableRow>
    );
};
